import { useEffect, useRef } from "react";
import useApiJira from "../api/administracion/useApiJira";

const CONTENEDOR_ID = "IndicadoresJira";

export default function JiraIndicadores() {
    const apiJira = useApiJira();
    const apiRef = useRef(null);

    apiRef.current = {
        source: apiJira,
    };

    useEffect(() => {
        if (
            typeof window.mountIndicadoresJira !==
            "function"
        ) {
            console.error(
                "No se encontró window.mountIndicadoresJira. " +
                "Verifica que esté cargado ui-widget.iife.js."
            );

            return undefined;
        }

        console.log(
            "API Jira enviada al microfrontend:",
            apiRef.current
        );

        console.log(
            "Método obtener:",
            apiRef.current?.source?.obtener
        );

        const desmontar =
            window.mountIndicadoresJira(
                CONTENEDOR_ID,
                {
                    api: apiRef.current,
                }
            );

        return () => {
            if (
                typeof desmontar === "function"
            ) {
                desmontar();
            }
        };
    }, []);

    return (
        <div
            id={CONTENEDOR_ID}
            style={{
                width: "100%",
                minHeight: "700px",
            }}
        />
    );
}